export class UserSetting {
}
export var UserLevel;
(function (UserLevel) {
    UserLevel["LEARNER"] = "LEARNER";
    UserLevel["ADMIN"] = "ADMIN";
    UserLevel["MANAGER"] = "MANAGER";
    UserLevel["TRAINER"] = "TRAINER";
})(UserLevel || (UserLevel = {}));
export class Notification {
}
export class Toggle {
}
export class Setting {
}
export class User {
    constructor(user) {
        this.location = user.location;
        this.avatar = user.avatar;
        this.loginId = user.loginId;
        this.role = user.role;
        this.token = user.token;
        this.userId = user.userId;
        this.profileId = user.profileId;
        this.companyId = user.companyId;
        this.managerId = user.managerId;
        this.firstName = user.firstName;
        this.middleName = user.middleName;
        this.lastName = user.lastName;
        this.phone = user.phone;
        this.smsNumber = user.smsNumber;
        this.email = user.email;
        this.altEmail = user.altEmail;
        this.organization = user.organization;
        this.position = user.position;
        this.department = user.department;
        this.employeeId = user.employeeId;
        ;
        this.policyId = user.policyId;
        ;
        this.avatarImg = user.avatarImg;
        this.validEmail = user.validEmail;
        this.validAltEmail = user.validAltEmail;
        this.validSms = user.validSms;
        this.addedByID = user.addedByID;
        this.modifiedByID = user.modifiedByID;
        this.deactByID = user.deactByID;
        this.deactMethod = user.deactMethod;
        this.active = user.active;
        this.dateAdded = user.dateAdded;
        this.dateModified = user.dateModified;
        this.dateDeact = user.dateDeact;
        this.dateExpire = user.dateExpire;
        this.dateLastLogin = user.dateLastLogin;
        this.ticketDesign = user.ticketDesign;
        this.shareFavorites = user.shareFavorites;
        this.sendInvites = user.sendInvites;
        this.graceDays = user.graceDays;
        this.trainReminders = user.trainReminders;
        this.passing = user.passing;
        this.language = user.language;
        this.notifications = user.notifications;
        this.userSettings = user.userSettings;
        this.toggles = user.toggles;
        this.devices = user.devices;
        this.settings = user.settings;
        this.currentDevice = user.currentDevice;
        this.tz = user.tz;
        this.groups = user.groups;
        this.showGroupActionBtn = user.showGroupActionBtn;
        this.selected = user.selected;
        this.userLevel = user.userLevel;
        this.timeZone = user.timeZone;
        this.timeFormat = user.timeFormat;
        this.dateDisplayFormat = user.dateDisplayFormat;
        this.longDateDisplayFormat = user.longDateDisplayFormat;
        this.notes = user.notes;
        this.secondaryPass = user.secondaryPass;
        this.signUpType = user.signUpType;
    }
}
//# sourceMappingURL=user.js.map